import { Price } from '@app/core/business/price';
import { Weight } from '@app/core/business/weight';
import { Address } from '@app/core/business/address';
import { OrderLine } from '@app/core/business/order/order-line';


export class Order {

  static hasDateCourte(order: Order): boolean  {
    return order.lines?.some(line => line.isDateCourte);
  }

  code: string;
  customerCode?: string;
  date?: string;
  validityStartDate?: string;
  validityEndDate?: string;
  customCode?: string;
  status?: string;
  statusLabel?: string;
  headerComment?: string;
  footerComment?: string;
  fileUrl?: string;
  invoiceCodes?: string[];
  deliveryNoteCodes?: string[];
  count?: number;
  weight?: Weight;
  price?: Price;
  deliveryDate?: string;
  deliveryAddress?: Address;
  lines?: OrderLine[];
  outOfStockLines?: OrderLine[];
  shippingUrl?: string;
  palletType?: string;
  palletFillRate?: string;
  orderType?: string; // CLA le 10/10/2019 - A/B - ajout du type de commande
  assignCode?: string; // CLA le 11/10/2019 - A/B - ajout de l'information d'affectation
  assignText?: string;
  cutOffPreco?: string;
  departureMagasin?: string;

  constructor() {
    this.invoiceCodes = new Array<string>();
    this.deliveryNoteCodes = new Array<string>();
    this.lines = new Array<OrderLine>();
    this.outOfStockLines = new Array<OrderLine>();
  }


}
